function updateTabButtonText(button) {
  const tabId = button.id.replace('tab-', '');
  const matchingTab = document.getElementById(`madara-tab-${tabId}`);

  if (!matchingTab) {
    button.remove(); // Remove the button if no matching tab is found
    return;
  }

  const tabTitle = matchingTab ? matchingTab.getAttribute('data-title') : null;
  button.textContent = tabTitle;
}

function initializeTabs() {
  const tabButtons = document.querySelectorAll('.madara-tabs__tab-button');
  const tabPanels = document.querySelectorAll('.madara-tabs__tab');

  tabButtons.forEach((button, index) => {
    updateTabButtonText(button);

    button.addEventListener('click', () => {
      // Remove active class from all buttons and tabs
      tabButtons.forEach(btn => btn.classList.remove('m-tag--active'));
      tabPanels.forEach(panel => panel.classList.remove('madara-tabs__tab--active'));

      // Add active class to clicked tab button and corresponding tab
      button.classList.add('m-tag--active');
      tabPanels[index].classList.add('madara-tabs__tab--active');
    });
  });
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initializeTabs);

// Re-initialize when Shopify section is reloaded
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.contains(document.querySelector('.madara-tabs__tabs'))) {
    initializeTabs();
  }
}); 